import { setupRegistry } from '@/plugins'

// Use import.meta.glob instead of require.context for Vite compatibility
const components = import.meta.glob('@/components/global/**/*.vue', { eager: true })

// Function to register global components with Vue 3
export const setupGlobalComponents = app => {
  Object.entries(components).forEach(([fileName, component]) => {
    // Get name of component, assumes PascalCase
    const componentName = fileName.split('/').pop().replace(/\.\w+$/, '')

    // Skip if already registered
    if (setupRegistry.components.has(componentName)) {
      return
    }

    // Mark as registered
    setupRegistry.components.add(componentName)
    // console.log('componentName', componentName)

    // Register component globally on the app instance
    app.component(
      componentName,
      // Look for the component options on `.default`, which will
      // exist if the component was exported with `export default`,
      // otherwise fall back to module's root.
      component.default || component,
    )
  })
}

// Export default for compatibility with existing imports
export default { setup: setupGlobalComponents }
